import request from '@/utils/axios'

//来源统计
export function fromAnalysis(form) {
    return request({
        url: '/record_log',
        method: 'get',
        params: form
    })
}

//账号密码登录
export function loginRequest(form) {
    return request({
        url: '/auth/login',
        method: 'post',
        params: form
    })
}

//验证码登录
export function codeLogin(form) {
    return request({
        url: '/auth/login_by_code',
        method: 'post',
        params: form
    })
}

//注册
//获取验证码
export function phoneCheck(form) {
    return request({
        url: '/auth/smsz',
        method: 'get',
        params: form
    })
}

//注销
export function toLogoff(form) {
    return request({
        url: '/account/logoff',
        method: 'get',
        params: form
    })
}

//注册
export function toRegister(form) {
    return request({
        url: '/auth/register',
        method: 'post',
        params: form
    })
}

//忘记密码
export function forgetPwd(form) {
    return request({
        url: '/auth/forget',
        method: 'post',
        params: form
    })
}

//修改密码
export function changePassword(form) {
    return request({
        url: '/auth/modifyPwd',
        method: 'post',
        params: form
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js